import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { ConfiguratorPartnership } from '@models';
import { DefaultHttpHeaders, ApiService } from '@services/api/api.service';

export interface GetPartnershipParams extends DefaultHttpHeaders {
  partnershipId: string;
}

@Injectable()
export class GetPartnershipService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  getPartnership(params: GetPartnershipParams): Observable<ConfiguratorPartnership> {
    const pathParams = {
      partnershipId: params.partnershipId,
    };
    return this.get<ConfiguratorPartnership>({
      suffix: `/configurator/partnershipCard/${pathParams.partnershipId}`,
      apiUrl: environment.configuratorApiUrl,
    });
  }
}
